// extracted by mini-css-extract-plugin
var _1 = "nInS4";
var _2 = "uWLuT";
var _3 = "s7Hk_";
var _4 = "NMqN0";
var _5 = "kRbiB";
var _6 = "rlkE7";
var _7 = "sfC2U";
var _8 = "FwcMP";
export { _1 as "arrow", _2 as "content", _3 as "elide", _4 as "icon", _5 as "tooltip", _6 as "variant-default", _7 as "variant-error", _8 as "variant-warning" }
